import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitokolhapurcab() {



const cardData = {
  keyword: "Mumbai to Kolhapur Cab",

headingDescription:
  "Omshree Cab provides safe and comfortable Mumbai to Kolhapur cab services for travelers seeking a convenient journey to one of Maharashtra’s cultural and historic cities. Whether you are planning a pilgrimage visit, a heritage tour, a weekend getaway, or a family trip, our cab service ensures reliable travel with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Kolhapur cab services.",

topPlaces: [
  {
    title: "Mahalaxmi Temple",
    description:
      "Mahalaxmi Temple is one of the most revered temples in Kolhapur, dedicated to Goddess Mahalaxmi. The temple features exquisite architecture, intricate carvings, and a spiritual ambiance that attracts devotees from across India. Visitors can participate in daily rituals, witness traditional ceremonies, and explore the temple complex. Traveling by cab ensures a comfortable journey from Mumbai, allowing devotees to reach early, avoid the hassle of local transport, and spend ample time experiencing the temple and its surroundings."
  },
  {
    title: "Panhala Fort",
    description:
      "Panhala Fort is a historic fort near Kolhapur known for its impressive hilltop location, sprawling architecture, and rich history dating back to the Maratha era. Visitors can explore the fort’s bastions, gates, temples, and scenic viewpoints that offer panoramic views of the surrounding landscape. A cab ride allows travelers to conveniently access the fort, enjoy a relaxed exploration of the site, and combine the visit with other nearby attractions without worrying about transportation."
  },
  {
    title: "Rankala Lake",
    description:
      "Rankala Lake is a serene freshwater lake in Kolhapur, surrounded by walking paths, gardens, and temples. It is a popular spot for evening strolls, boating, and photography. The lake area also hosts cultural events and local festivals, providing a glimpse into Kolhapur’s traditions. Traveling by cab allows visitors to enjoy a leisurely visit, explore nearby markets and eateries, and experience the lake at a comfortable pace without the stress of public transport."
  },
  {
    title: "New Palace",
    description:
      "New Palace is a historic palace in Kolhapur that showcases the royal heritage of the Kolhapur rulers. The palace features beautiful architecture, a museum with royal artifacts, weapons, and paintings, and provides insights into the city’s history. Visitors can explore the museum, take photographs, and appreciate the grandeur of the Maratha dynasty. A cab service ensures hassle-free travel, making it easy to visit the palace along with other Kolhapur attractions in a single day."
  },
  {
    title: "Jyotiba Temple",
    description:
      "Jyotiba Temple, located on a hill near Kolhapur, is dedicated to Lord Jyotiba and is an important pilgrimage site for devotees. The temple is accessed via a scenic climb or ropeway, offering panoramic views of the surrounding Sahyadri hills. Travelers can enjoy spiritual activities, local fairs, and festivals celebrated at the temple. A cab ride provides convenient transport to the base and the temple itself, allowing visitors to focus on the pilgrimage experience comfortably."
  },
  {
    title: "Bhavani Mandap",
    description:
      "Bhavani Mandap is a historic building in Kolhapur that served as a court for the Maratha rulers. The structure exhibits traditional architecture, ornate pillars, and an interesting cultural history. Visitors can learn about the city’s royal past and take in the surrounding streets and markets. A cab service ensures easy access, enabling travelers to explore Bhavani Mandap along with nearby attractions like Mahalaxmi Temple and Rankala Lake efficiently."
  },
  {
    title: "Chandgad Fort",
    description:
      "Chandgad Fort is located near Kolhapur and is known for its scenic hilltop views, trekking opportunities, and historical significance. Visitors can enjoy nature walks, explore the fort ruins, and experience the lush greenery of the region. Traveling by cab provides convenient access to the base of the fort, allowing travelers to plan a comfortable day trip from Kolhapur while combining it with other sightseeing spots."
  },
  {
    title: "Shalini Palace",
    description:
      "Shalini Palace is a heritage hotel and former royal residence in Kolhapur that showcases beautiful architecture, landscaped gardens, and vintage interiors. Visitors can admire the palace’s grandeur, take photographs, and enjoy nearby walking areas. Using a cab makes visiting Shalini Palace hassle-free, enabling travelers to include it alongside other local attractions for a complete Kolhapur sightseeing experience."
  },
  {
    title: "Mahadji Shinde Chhatri",
    description:
      "Mahadji Shinde Chhatri is a historical memorial in Kolhapur dedicated to the Maratha ruler Mahadji Shinde. The site features intricate carvings, impressive architecture, and a peaceful ambiance for visitors. Traveling by cab allows for easy access, helping tourists explore this cultural site without worrying about parking or local transport challenges."
  },
  {
    title: "Kumbhoj Ganpati Temple",
    description:
      "Kumbhoj Ganpati Temple is a revered temple near Kolhapur, dedicated to Lord Ganesha. The temple attracts devotees seeking blessings and participating in rituals and festivals. A cab ride provides convenient travel from Kolhapur city, enabling pilgrims to enjoy the spiritual experience fully while combining the visit with other important religious and cultural sites in the region."
  }
],

services: [
{
name: "Mumbai to Kolhapur Cab",
description: "Mumbai to Kolhapur cab service offers comfortable long-distance travel between the financial capital and the historic city of Kolhapur. Our AC sedans, SUVs, and premium vehicles ensure a smooth highway journey via the Mumbai–Pune–Kolhapur route. Professional drivers provide safe driving for long-distance travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for family trips, temple visits, and business travel."
},
{
name: "Mumbai to Kolhapur Taxi",
description: "Mumbai to Kolhapur taxi service provides convenient road transportation for passengers traveling to Kolhapur. Comfortable AC vehicles ensure relaxed seating for long-distance journeys. Experienced drivers ensure safe and efficient highway travel. Flexible pickup options are available across Mumbai. Perfect for family trips, tourism, and corporate travel."
},
{
name: "Mumbai to Kolhapur Cab Service",
description: "Mumbai to Kolhapur cab service is designed for passengers seeking reliable intercity travel. Well-maintained vehicles and professional drivers ensure smooth and safe highway journeys. Pickup is available from all locations in Mumbai including airport terminals. Spacious seating and AC comfort enhance long-distance travel experience."
},
{
name: "Mumbai to Kolhapur Taxi Service",
description: "Mumbai to Kolhapur taxi service offers dependable transportation for family trips, temple visits, and business travel. Comfortable AC vehicles ensure relaxed highway journeys. Professional drivers handle long-distance travel efficiently. Flexible booking options allow easy trip planning."
},
{
name: "Cab from Mumbai to Kolhapur",
description: "Cab from Mumbai to Kolhapur provides a convenient private travel option for passengers planning intercity journeys. Comfortable vehicles ensure smooth highway travel. Experienced drivers ensure safe and timely arrival. Ideal for tourism, business trips, and family travel."
},
{
name: "Taxi from Mumbai to Kolhapur",
description: "Taxi from Mumbai to Kolhapur offers reliable long-distance transportation with comfortable AC vehicles and experienced drivers. The service is ideal for families, tourists, and corporate travelers. Flexible pickup options across Mumbai ensure convenient travel planning."
},
{
name: "Mumbai to Kolhapur Cab Booking",
description: "Mumbai to Kolhapur cab booking allows travelers to reserve vehicles quickly for comfortable intercity travel. Instant booking confirmation and flexible pickup options simplify trip planning. Sedan, SUV, and premium vehicles are available for different travel needs."
},
{
name: "Mumbai to Kolhapur Taxi Booking Online",
description: "Online taxi booking from Mumbai to Kolhapur allows passengers to reserve vehicles instantly from anywhere. Easy booking process and quick confirmation ensure reliable travel planning. AC vehicles and professional drivers provide smooth highway journeys."
},
{
name: "Mumbai to Kolhapur Cab Price",
description: "Mumbai to Kolhapur cab price is designed to offer competitive and transparent fare options. Customers can select sedan, SUV, or luxury vehicles based on comfort and budget. Clear pricing ensures no hidden charges."
},
{
name: "Mumbai to Kolhapur Taxi Fare",
description: "Mumbai to Kolhapur taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with clear fare structure. Comfortable vehicles ensure relaxed long-distance travel."
},
{
name: "Mumbai to Kolhapur One Way Cab",
description: "One way cab from Mumbai to Kolhapur is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel costs significantly. AC vehicles ensure comfortable highway travel."
},
{
name: "Mumbai to Kolhapur Round Trip Taxi",
description: "Round trip taxi from Mumbai to Kolhapur offers convenient return travel for passengers planning short trips or weekend visits. Flexible return scheduling allows travelers to explore Kolhapur comfortably."
},
{
name: "Mumbai to Kolhapur Innova Cab",
description: "Innova cab from Mumbai to Kolhapur is perfect for families and group travelers requiring spacious seating and luggage capacity. The premium MPV provides comfortable seating for long-distance travel."
},
{
name: "Mumbai to Kolhapur Ertiga Cab",
description: "Ertiga cab from Mumbai to Kolhapur offers comfortable travel for medium-size families and small groups. Spacious interiors ensure relaxed seating during the journey. AC comfort keeps passengers comfortable."
},
{
name: "Mumbai to Kolhapur Sedan Cab",
description: "Sedan cab from Mumbai to Kolhapur provides economical travel for couples and small families. Vehicles like Swift Dzire and Etios offer comfortable seating and smooth highway journeys."
}
],

tableData: [
["Mumbai to Kolhapur Cab","Mumbai to Kolhapur Taxi"],
["Mumbai to Kolhapur Cab Service","Mumbai to Kolhapur Taxi Service"],
["Cab from Mumbai to Kolhapur","Taxi from Mumbai to Kolhapur"],
["Mumbai to Kolhapur Cab Booking","Mumbai to Kolhapur Taxi Booking Online"],
["Mumbai to Kolhapur Cab Price","Mumbai to Kolhapur Taxi Fare"],
["Mumbai to Kolhapur One Way Cab","Mumbai to Kolhapur Round Trip Taxi"],
["Mumbai to Kolhapur Innova Cab","Mumbai to Kolhapur Ertiga Cab"],
["Mumbai to Kolhapur Sedan Cab","Best Cab Mumbai to Kolhapur"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling long-distance routes like Mumbai to Kolhapur. They are familiar with NH48 highway traffic patterns, rest stops, and the fastest routes, ensuring a safe, smooth, and comfortable journey throughout the trip."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and honest pricing for Mumbai to Kolhapur cab services. All fares, per-kilometer charges, and trip packages are shared before booking so customers can travel without worrying about hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early morning, late night, or at any convenient time, Omshree Cabs provides 24/7 cab booking services. Our team ensures quick confirmation and dependable travel support for Mumbai to Kolhapur journeys."
  },
  {
    WhyChooseheading: "Clean AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles designed for comfortable long-distance travel. Every car is cleaned and sanitized before each trip so passengers enjoy a fresh and hygienic ride."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "Choose from one-way trips, round trips, or multi-day Kolhapur travel plans depending on your travel needs. Omshree Cabs offers flexible schedules so you can plan your journey conveniently."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We provide a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles for group travel. You can select the perfect vehicle based on your comfort and group size."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "Omshree Cabs offers doorstep pickup from homes, offices, hotels, and airports anywhere in Mumbai. Our driver arrives at your location on time so your Mumbai to Kolhapur journey begins smoothly."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Our service focuses on punctuality and customer satisfaction. Omshree Cabs ensures timely pickup, safe driving practices, and a smooth journey so you reach Kolhapur comfortably and on schedule."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Kolhapur by cab?", answer: "The distance from Mumbai to Kolhapur is approximately 375 km and usually takes around 7–8 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Kolhapur cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Kolhapur." },
  { question: "Which vehicles are available for Mumbai to Kolhapur travel?", answer: "We provide sedans, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and travel comfort." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we offer direct pickup from Mumbai Airport for Kolhapur cab bookings." },
  { question: "Can we visit Mahalakshmi Temple in Kolhapur during the trip?", answer: "Yes, many travelers book Mumbai to Kolhapur cabs to visit the famous Mahalakshmi Temple and other attractions." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle in our fleet is fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and festival seasons." },
  { question: "Do you offer round-trip packages?", answer: "Yes, Omshree Cabs offers convenient round-trip and multi-day travel packages for Kolhapur." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Joshi",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Kolhapur trip. The driver was very professional and the car was extremely comfortable for the long journey. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anita Kulkarni",
    feedback:
      "Our family trip to Kolhapur with Omshree Cabs was fantastic. On-time pickup, smooth highway driving, and transparent pricing made the entire journey stress-free.",
    rating: 5
  }
];


























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "description": "Book Mumbai to Kolhapur Cab with Omshree Cab for safe, comfortable, and reliable outstation travel. Choose from Innova, Ertiga, and Sedan cabs for one-way or round trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Kolhapur.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2700"
  }
};



  return (
    <div>
   
<Helmet>
  <title>Mumbai to Kolhapur Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Kolhapur Cab with Omshree Cab for safe, comfortable, and reliable outstation travel. Choose from Innova, Ertiga, and Sedan cabs for one-way or round trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Kolhapur." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>   



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokolhapurcab;